export default __webpack_public_path__ + "static/media/Slide7.63f4aa71.PNG";